import request from '@/api/request.js'
export function deptPageList(data, page) {
  return request({
    url: '/agency/deptPageList?' + `pageSize=${page.pageSize}&pageNum=${page.pageNum}`,
    method: 'post',
    data: data
  })
}
export function insert(data) {
  return request({
    url: '/agency/insert',
    method: 'post',
    data: data
  })
}
export function deleteInstitution(data) {
  return request({
    url: '/agency/delete',
    method: 'post',
    data: data
  })
}
export function findById(data) {
  return request({
    url: '/agency/findById',
    method: 'post',
    data: data
  })
}
export function validation() {
  return request({
    url: '/agency/validation',
    method: 'get',
  })
}
//新增所属大区
export function addDeptArea(data) {
  return request({
    url: '/agency/addDeptArea',
    method: 'post',
    data: data
  })
}
// 编辑大区
export function editDeptArea(data) {
  return request({
    url: '/agency/editDeptArea',
    method: 'post',
    data: data
  })
}
//删除大区
export function delDeptArea(data) {
  return request({
    url: '/agency/delDeptArea/'+data,
    method: 'delete'
  })
}
//获取大区信息
export function getDeptAreaList() {
  return request({
    url: '/agency/allDeptArea',
    method: 'get'
  })
}
export default {
  deptPageList,
  insert,
  findById,
  deleteInstitution,
  validation,
  addDeptArea,
  editDeptArea,
  delDeptArea,
  getDeptAreaList
}